import { defineComponent, ref } from '@vue/composition-api';
import useStore from '../store';
export default defineComponent({
  emits: ['to-post'],
  setup: function setup(props, ctx) {
    var store = useStore();
    var finalRef = ref(null);
    return {
      store: store,
      finalRef: finalRef
    };
  }
});